<ion-content *ngIf="auftrag && unterschrift">
  <div class="header-container">
    <div class="upper-content black-text">Unterschrift für Auftrag: {{ auftrag.Auftragsnummer }}</div>
    <div *ngIf="statusmeldungAnzeigen" class="upper-content2 black-text"> {{ statusmeldungen | translate }} </div>

    <div *ngIf="positionenText" class="upper-content2 black-text positionen-text">{{ positionenText | translate }}</div>

    <div *ngIf="auftrag.UnterschriftText" class="unterschrift-text-container">
      <ion-item lines="none">
        <ion-checkbox
                      [(ngModel)]="unterschriftTextBestaetigt"
                      labelPlacement="end"
                      justify="start">
          <ion-label class="ion-text-wrap">
            {{ auftrag.UnterschriftText }}
          </ion-label>
        </ion-checkbox>
      </ion-item>
    </div>
  </div>

  <app-unterschrift (signaturVorhanden)=" onSignaturVorhanden(unterschriftComponent)" #unterschriftComponent></app-unterschrift>
  <div class="lower-content black-text">{{ unterschrift.Name }} ({{ rolle }}), {{ datumHeute }}, {{ auftrag.Abholadresse.Ort }}</div>
</ion-content>

<canvas #hiddenCanvans id="hiddenCanvas"></canvas>

<img *ngIf="logo" class="unterschrift-logo-img" src="{{'data:image/jpg;base64,' + logo}}" />

<div class="buttons">
  <ion-button [color]="speichernButtonColor" [disabled]="speichernDisabled" appClick (clicked)="onSpeichern($event)"><ion-icon name="checkmark"></ion-icon></ion-button>
  <ion-button color="warning" appClick (clicked)="onReset($event)"><ion-icon name="refresh"></ion-icon></ion-button>
  <ion-button color="light" appClick (clicked)="onAbbrechen($event)"><ion-icon name="close"></ion-icon></ion-button>
</div>